import { generatePath, useNavigate, useParams } from 'react-router-dom'
import { faArrowDownToBracket } from '@fortawesome/pro-regular-svg-icons/faArrowDownToBracket'
import { Icon } from 'src/components'
import { paths } from 'src/router/paths'
import i18n from 'src/i18n'
import { useCustomEvent } from 'src/hook/useCustomEvent'
import { CommunityListMenuEventNames } from '../../communityListMenu.types'
import { ActionImportCommunityProps, PathParams } from './actionImportCommunity.types'

const ActionImportCommunity = ({ group }: ActionImportCommunityProps) => {
  const { lang, membership } = useParams() as PathParams
  const navigate = useNavigate()
  const { emitEvent } = useCustomEvent()

  const handleImportCommunity = () => {
    const path = generatePath(paths.SELECTED_MIGRATION_PATH, {
      lang,
      membership
    })

    emitEvent(CommunityListMenuEventNames.IMPORT_COMMUNITY, { group })
    navigate(path)
  }

  return (
    <button
      className="_d-flex _p-0 _align-items-center _w-full hot-button _border-0 _text-1 _text-gray-900"
      onClick={handleImportCommunity}
    >
      <span className="_d-flex _py-4 _pl-4 _pr-0">
        <Icon icon={faArrowDownToBracket} className="_text-gray-900 _w-5" />
      </span>

      <span className="_text-gray-600 _font-weight">
        {i18n.t('sidebar_menu.community.actions.import')}
      </span>
    </button>
  )
}

export default ActionImportCommunity
